import {
  getDirectusField
} from "directus/src/operations";


export async function fetchMilestoneStatuses() {
  try {
    const response = await getDirectusField("milestones", "status");
    const data = response.meta.options.choices.map((status) => {
      return { name: status.text, id: status.value };
    });
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}
